import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5 text-size-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppButton, {
      href: _ctx.externalLink.contact,
      size: "small",
      block: "",
      rounded: "",
      class: "mb-3"
    }, {
      default: _withCtx(() => [
        _createTextVNode("\n      お問い合わせフォーム\n    ")
      ], undefined, true),
      _: 1
    }, 8, ["href"])
  ]))
}